import React from "react";
import { Message } from "components/Atoms/Message";
import { Button } from "semantic-ui-react";
import SubscriptionPricing from "../components/SubscriptionPricing";
import { TermsAndConditions } from "./TermsAndConditions";

interface Props {
  session: server.dto.ClientOnboardingSession
  onFinished: (newSession: server.dto.ClientOnboardingSession) => void
}

const Subscription = (props: Props) => {
  const [userCount, setUserCount] = React.useState(props.session.subscription.userCount);
  const [billingCycle, setBillingCycle] = React.useState<server.dto.BillingCycles>();
  const [subscriptionHasError, setSubscriptionHasError] = React.useState(false);
  const [termsHasError, setTermsHasError] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [serverErrors, setServerErrors] = React.useState<string[]>([]);
  const [hasAgreedWithTerms, setHasAgreedWithTerms] = React.useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();

    setTermsHasError(!hasAgreedWithTerms);
    setSubscriptionHasError(!billingCycle);

    if (!hasAgreedWithTerms || !billingCycle) {
      return;
    }

    setIsSubmitting(true);

    try {
      const res = await window.CoreApi.ClientOnboardingOpen.SetSubscription({
        secret: props.session.secret,
        userCount,
        billingCycle
      });

      if (res.data.errors.length > 0) {
        setServerErrors(res.data.errors.map(e => e.message));
        return;
      }
      window.location.reload();
    } catch {
      setServerErrors([RESX.GeneralLabels.SomethingUnexpectedHappened]);
    } finally {
      setIsSubmitting(false);
    }
  };

  return <form onSubmit={onSubmit} style={{ display: "inline" }}>

    <div className="flex margin-bottom-huge justify-space-between">
      <SubscriptionPricing
        billingCycle="monthly"
        numberOfUsers={userCount}
        onNumberOfUsersChanged={setUserCount}
        isSelected={billingCycle === "monthly"}
        isOtherSelected={billingCycle === "annually"}
        onSelected={() => {
          setBillingCycle("monthly");
          setSubscriptionHasError(false);
        }}
        error={subscriptionHasError}
        pricing={props.session.agencyMonthlyPricing}
      />
      <SubscriptionPricing
        billingCycle="yearly"
        discount={10}
        numberOfUsers={userCount}
        onNumberOfUsersChanged={setUserCount}
        isSelected={billingCycle === "annually"}
        isOtherSelected={billingCycle === "monthly"}
        onSelected={() => {
          setBillingCycle("annually");
          setSubscriptionHasError(false);
        }}
        error={subscriptionHasError}
        pricing={props.session.agencyAnnuallyPricing}
      />
    </div>

    <TermsAndConditions
      hasAgreedWithTerms={hasAgreedWithTerms}
      setHasAgreedWithTerms={setHasAgreedWithTerms}
      hasError={termsHasError}
      setHasError={setTermsHasError}
    />

    <div className="flex margin-top">
      <div className="grow1 margin-right">
        {serverErrors.length > 0 && <Message type="error">
          {serverErrors.map((error) => <div key={error}>{error}</div>)}
        </Message>}
      </div>
      <div>
        <Button
          primary
          type="submit"
          onClick={onSubmit}
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          {RESX.Buttons.btnNextStep}
        </Button>
      </div>
    </div>
  </form>
};

export default Subscription;